var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-option",class:_vm.classes,on:{"click":function($event){return _vm.select()}}},[_c('label',{domProps:{"textContent":_vm._s(_vm.label)}})])}
var staticRenderFns = []

export { render, staticRenderFns }